import { useCallback, useState } from "react";
import { Button, Col, Radio, Row } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

import styles from "../components-css/SaasTheme.module.css";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";

export const ThemeModal = ({ themes, saasTheme, setSaasTheme, setModal }) => {
  const [theme, setTheme] = useState(saasTheme);

  const onChange = e => {
    setTheme(e.target.value);
  };

  const handleCancel = useCallback(() => {
    setModal(false);
    setSaasTheme(saasTheme);
  }, [saasTheme, setModal, setSaasTheme]);

  const handleOk = useCallback(() => {
    setSaasTheme(theme);
    setModal(false);
  }, [setModal, setSaasTheme, theme]);

  return (
    <div className={styles.dropModal}>
      <Header handleCancel={handleCancel} />
      <div className={styles.dropModalBody}>
        <Radio.Group value={theme} style={{ width: "100%" }} onChange={onChange}>
          <List list={themes} />
        </Radio.Group>
      </div>
      <Footer handleOk={handleOk} />
    </div>
  );
};

export const ThemeSelect = ({ show }) => {
  const handleShow = () => {
    show(true);
  };
  return (
    <div className={styles.dropButton} onClick={handleShow}>
      <img src={`${settings.S3CDN}${settings.viewAssetsPath}theme.png`} width="14" alt="icon" />
      <span className={styles.dropText}>Change theme</span>
    </div>
  );
};

const Header = ({ handleCancel }) => {
  return (
    <header>
      <span>
        <img src={`${settings.S3CDN}${settings.viewAssetsPath}theme.png`} width="20" alt="icon" />
        <span className={styles.dropModalTitle}>Theme</span>
      </span>
      <span className={styles.dropModalClose} onClick={handleCancel}>
        <CloseCircleOutlined />
      </span>
    </header>
  );
};

const Footer = ({ handleOk }) => {
  return (
    <footer>
      <Button block shape="round" size="large" type="primary" onClick={handleOk}>
        Apply
      </Button>
    </footer>
  );
};

const List = ({ list }) => {
  return (
    <Row gutter={[20, 20]}>
      {list.map(item => (
        <Col span={12} key={item.value}>
          <Radio.Button className={styles.themeItem} value={item.value}>
            <p className={styles.itemTitle}>{item.label}</p>
            <img src={item.logo} alt="" />
          </Radio.Button>
        </Col>
      ))}
    </Row>
  );
};
